import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';

import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0F00Model } from './kymw0f00.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';

import { FlexGrid } from '@grapecity/wijmo.grid';
import { KYMW0F00InputModel } from './vo/kymw0f00-input.model';
import { GetGroupingListService } from './api-services/get-grouping-list.service';

/**
 * グルーピング選択画面を管理するクラス
 *
 * @export KYMW0F00Component
 * @class KYMW0F00Component
 */
@Component({
  selector: 'app-kymw0f00',
  templateUrl: 'kymw0f00.component.html',
  styleUrls: ['kymw0f00.component.scss'],
  providers: [
    GetGroupingListService
  ],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0F00Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_GroupingInfoList', { static: true }) dtg_GroupingInfoList: FlexGrid;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;

  @ViewChild('cmb_Coop142', { static: true }) cmb_Coop142: ElementRef;
  @ViewChild('cmb_Coop163', { static: true }) cmb_Coop163: ElementRef;
  @ViewChild('cmb_Coop185', { static: true }) cmb_Coop185: ElementRef;
  @ViewChild('cmb_Coop240', { static: true }) cmb_Coop240: ElementRef;
  @ViewChild('cmb_Coop210', { static: true }) cmb_Coop210: ElementRef;
  @ViewChild('cmb_Coop302', { static: true }) cmb_Coop302: ElementRef;
  @ViewChild('cmb_Coop515', { static: true }) cmb_Coop515: ElementRef;
  @ViewChild('cmb_Coop451', { static: true }) cmb_Coop451: ElementRef;

  // 親画面からの連携値
  public setKYMW0F00Parameter: Function;

  // 受渡し情報
  private inputVo: KYMW0F00InputModel = null;

  public kymw0F00Model: KYMW0F00Model = new KYMW0F00Model();

  /**
   *Creates an instance of KYMW0F00Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0F00Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getGroupingListService: GetGroupingListService,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /*--------------------------------------------------------------------------------------------------
    初期処理
  ---------------------------------------------------------------------------------------------------*/

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0F00';

    this.kymw0F00Model.kymw0F00Component = this;

    // 画面制御
    if (this.inputVo != null) {
      // モデルに値を反映する
      this.kymw0F00Model.coop142 = this.inputVo.EnableCoop142;
      this.kymw0F00Model.coop163 = this.inputVo.EnableCoop163;
      this.kymw0F00Model.coop185 = this.inputVo.EnableCoop185;
      this.kymw0F00Model.coop240 = this.inputVo.EnableCoop240;
      this.kymw0F00Model.coop210 = this.inputVo.EnableCoop210;
      this.kymw0F00Model.coop302 = this.inputVo.EnableCoop302;
      this.kymw0F00Model.coop515 = this.inputVo.EnableCoop515;
      this.kymw0F00Model.coop451 = this.inputVo.EnableCoop451;

      // コンボボックスの活性非活性制御
      setTimeout(() => {
        this.plessEnabledSetting();
        this.btn_Display.nativeElement.focus();
      });
      this.dtg_GroupingInfoList.itemsSourceChanged.addHandler(() => {
        this.dtg_GroupingInfoList.select(-1, -1);
      });
    }
  }
  public plessEnabledSetting() {
    this.coopCombEnableControl(this.cmb_Coop142, this.inputVo.EnableCoop142);
    this.coopCombEnableControl(this.cmb_Coop163, this.inputVo.EnableCoop163);
    this.coopCombEnableControl(this.cmb_Coop185, this.inputVo.EnableCoop185);
    this.coopCombEnableControl(this.cmb_Coop240, this.inputVo.EnableCoop240);
    this.coopCombEnableControl(this.cmb_Coop210, this.inputVo.EnableCoop210);
    this.coopCombEnableControl(this.cmb_Coop302, this.inputVo.EnableCoop302);
    this.coopCombEnableControl(this.cmb_Coop515, this.inputVo.EnableCoop515);
    this.coopCombEnableControl(this.cmb_Coop451, this.inputVo.EnableCoop451);
  }

  /**
   * 表示ボタン押下イベント
   */
  public eventDisplay_CLICKHandler(): void {
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw0F00Model.getGroupingDataVo();
    this.getGroupingListService.execute(this.kymw0F00Model, vo);
  }

  /**
   * 設定ボタン押下イベント
   */
  public eventSet_CLICKHandler(): void {
    // グルーピング情報が選択されていない場合、エラーとする
    if (!this.dtg_GroupingInfoList.selectedItems[0]) {
      this.dialogServiceSub.openAlertGetMessage('E0148', ['グルーピング情報']);
      return;
    }

    // 呼び出し元の画面に検索条件を返却する
    this.setKYMW0F00Parameter(this.kymw0F00Model.getKYMW0F00OutputVo());

    // 画面を終了する
    this.onClickClose();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Util Area
  ///////////////////////////////////////////////////////////////////////////////////////////

  /**
   * 生協コンボボックスの活性制御
   */
  private coopCombEnableControl(cmb: any, enableMode: string): void {
    if (enableMode === '0') {
      this.plessEnabled(cmb, true);
    } else if (enableMode === '1') {
      this.plessEnabled(cmb, true);
    } else {
      this.plessEnabled(cmb, false);
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0F00Component
   */
  public setInterfaceParam(param: any): void {
    // 親画面のinputVOをそのまま受け取る
    this.inputVo = param;
  }
}
